var map = {
	"./Add-extra-sit/Default.svg": 637,
	"./Add-time/Default.svg": 2009,
	"./Canel-order/Default.svg": 2010,
	"./Driver-help/Default.svg": 2011,
	"./Fix/Default.svg": 638,
	"./Insurance/Default.svg": 2012,
	"./Loader/Default.svg": 639,
	"./Packaging/Default.svg": 640,
	"./Round-trip/Default.svg": 641,
	"./Time-to-load/Default.svg": 2013
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;



//////////////////
// WEBPACK FOOTER
// ./client/components/InstantBookingScreen/Icons ./~/svg-inline-loader!^\.\/.*$
// module id = 667
// module chunks = 0